/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Container,
  CssBaseline,
  FormControlLabel,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../../assets/styles/pages/ShopRequest';
import Header from '../../../../components/Header';

// import svg
import { ReactComponent as IconPlus } from '../../../../assets/images/svg/shops/request/button_mais.svg';
import { ReactComponent as IconLess } from '../../../../assets/images/svg/shops/request/button_menos.svg';
import { ReactComponent as IconChecked } from '../../../../assets/images/svg/shops/request/icon_check_ok.svg';
import { ReactComponent as IconCheck } from '../../../../assets/images/svg/shops/request/icon_check.svg';
import { ReactComponent as IconArrowRight } from '../../../../assets/images/svg/shops/request/icon_seta_direita.svg';
import { ReactComponent as IconInfo } from '../../../../assets/images/svg/utils/info.svg';
import { getStorege, saveStorege } from '../../../../helpers/db_storage';
import { FormatPrice } from '../../../../helpers/utils/Formating';
import { handleSaveOptionLevelCartStorage } from '../../../../helpers/cart/optionLevel';
import { CalcCartProduct } from '../../../../helpers/utils/CalcProduct';
import { ModalMessage } from '../../../../components/Modal/Message';

const styleModal = {
  position: 'absolute' as const,
  top: '100%',
  height: 850,
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  bgcolor: 'background.paper',
  border: '2px solid #ffffff',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

const styleModalItemMenu = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const RequestOptionLevel: React.FC = () => {
  const classeStyle = useStyles();
  const {
    idRestaurante,
    id_product,
    id_request_menu,
    id_promotion,
    des_promotion,
  }: any = useParams();

  const navigate = useNavigate();

  const [qtOptionLevelMax, setQtOptionLevelMax] = useState<number>(0);
  const [vlProduct, setVlProduct] = useState<any>();
  const [product, setProduct] = useState<any>();
  const [optionLevel, setOptionLevel] = useState<any>([]);
  const [openUserNotParams, setOpenUserNotParams] = useState(false);
  const [errorInfo, setErrorInfo] = useState('');
  const [openModalZoonImgProduct, setOpenModalZoonImgProduct] = useState(false);
  const [optionSelected, setOptionSelected] = useState<any>();

  const handleToPage = (url: string): any => {
    return navigate(url, { replace: true });
  };

  const handleSelectOptionLevel = (event: any): any => {
    const idOpcaoNivel = event.target.value;
    const { checked } = event.target;

    const resultOptionLevelSelected: any = product.niveis[
      product.optionLevelInit
    ].opcoesNivel.find(
      (optionLevelData: any) =>
        Number(optionLevelData.idOpcaoNivel) === Number(idOpcaoNivel),
    );

    const optionLevelSelected = optionLevel.findIndex(
      (optionLevelData: any) =>
        Number(optionLevelData.idOpcaoNivel) === Number(idOpcaoNivel),
    );

    if (
      qtOptionLevelMax >= product.niveis[product.optionLevelInit].qtMaxOpcao &&
      checked
    ) {
      setOpenUserNotParams(true);
      setErrorInfo('Quantidade máxima de opções atingida');
      return;
    }

    resultOptionLevelSelected.qtItens = 1;
    resultOptionLevelSelected.flag_type_price =
      product.niveis[product.optionLevelInit].flgTipoPreco;
    resultOptionLevelSelected.qtMaxOpcao =
      product.niveis[product.optionLevelInit].qtMaxOpcao;
    resultOptionLevelSelected.qtMinOpcao =
      product.niveis[product.optionLevelInit].qtMinOpcao;

    if (checked && optionLevelSelected === -1) {
      setOptionLevel([...optionLevel, resultOptionLevelSelected]);
    } else if (!checked && optionLevelSelected !== -1) {
      optionLevel.splice(optionLevelSelected, 1);
      setOptionLevel([...optionLevel]);
    }
  };

  const handleSetQtOptionLevel = (id: number, qt: number, type: string) => {
    const optionLevelSelected = optionLevel.findIndex(
      (optionLevelData: any) =>
        Number(optionLevelData.idOpcaoNivel) === Number(id),
    );
    if (
      qtOptionLevelMax >= product.niveis[product.optionLevelInit].qtMaxOpcao &&
      type !== 'decrement'
    ) {
      setOpenUserNotParams(true);
      setErrorInfo('Quantidade máxima de opções atingida');
      return;
    }

    if (qt >= 1) {
      const optionLevelQt = optionLevel[optionLevelSelected];
      optionLevelQt.qtItens = qt;
      optionLevel.splice(optionLevelSelected, 1);
      setOptionLevel([...optionLevel, optionLevelQt]);
    } else {
      optionLevel.splice(optionLevelSelected, 1);
      setOptionLevel([...optionLevel]);
    }
  };

  const handleAddOptionLevelCart = async (): Promise<any> => {
    if (
      product.niveis[product.optionLevelInit].qtMinOpcao > 0 &&
      qtOptionLevelMax < product.niveis[product.optionLevelInit].qtMinOpcao
    ) {
      setOpenUserNotParams(true);
      setErrorInfo(
        `Selecione pelo menos ${
          product.niveis[product.optionLevelInit].qtMinOpcao
        } opção(oes)`,
      );
      return;
    }

    const result = handleSaveOptionLevelCartStorage(
      optionLevel,
      {
        idShop: window.atob(idRestaurante),
        idPedidoCardapio: window.atob(id_request_menu),
        idCardapio: window.atob(id_product),
        flag_type_price: product.niveis[product.optionLevelInit].flgTipoPreco,
      },
      'optionLevel',
      '@mais/delivery/shop/request/product/treat',
    );

    if (result?.remove) {
      toast.info('Seu carrinho expirou, por favor faça seu pedido novamente.');
      handleToPage(`/shop/detail/list/product/subcategorie/${idRestaurante}`);
      return;
    }

    if (product.niveis.length - 1 > product.optionLevelInit) {
      product.optionLevelInit = parseInt(product.optionLevelInit, 10) + 1;
      setQtOptionLevelMax(0);
      setOptionLevel([]);
      saveStorege('@mais/delivery/Shops/Menu/Product', product);
      handleToPage(
        `/shop/request/level/${idRestaurante}/${id_product}/${id_request_menu}${
          id_promotion ? `/${id_promotion}/${des_promotion}` : ''
        }`,
      );
      return;
    }

    if (id_request_menu) {
      handleToPage(
        `/shop/request/note/${idRestaurante}/${id_product}${
          id_promotion ? `/${id_promotion}/${des_promotion}` : ''
        }`,
      );
    }
  };

  const closeModal = async () => {
    await new Promise((resolve) => {
      setTimeout(resolve, 5000);
    });
    setOpenUserNotParams(false);
  };

  const zoomImg = (data: any) => {
    setOptionSelected(data);
    setOpenModalZoonImgProduct(true);
  };

  useEffect(() => {
    async function MaxQt() {
      let qtMax = 0;
      if (optionLevel.length === 0) {
        setQtOptionLevelMax(0);
        return;
      }
      for (let index = 0; index < optionLevel.length; index += 1) {
        const element = optionLevel[index];
        qtMax += element.qtItens;
        setQtOptionLevelMax(qtMax);
      }
    }
    MaxQt();
  }, [optionLevel]);

  useEffect(() => {
    if (openUserNotParams) {
      closeModal();
    }
  }, [openUserNotParams]);

  useEffect(() => {
    const resultProduct = getStorege('@mais/delivery/Shops/Menu/Product');

    setProduct(resultProduct);
  }, []);

  useEffect(() => {
    setVlProduct('');

    async function CalcProduct() {
      const resultRequestTreat = getStorege(
        '@mais/delivery/shop/request/product/treat',
      );
      const resultProduct = resultRequestTreat?.pedido_cardapio?.find(
        (productData: any) =>
          Number(productData.idCardapio) === Number(product?.idCardapio),
      );
      if (resultProduct) {
        const resultCalc = await CalcCartProduct(resultProduct, '', '', [
          ...(resultRequestTreat.opcoes?.length > 0
            ? resultRequestTreat.opcoes
            : []),
          ...optionLevel,
        ]);
        setVlProduct(resultCalc);
      }
    }
    CalcProduct();
  }, [product, optionLevel]);

  useEffect(() => {
    const dataStorageShop = getStorege('@mais/delivery/shop');
    const dataStorageCart = getStorege(
      '@mais/delivery/shop/request/product/treat',
    );
    if (!dataStorageShop || !dataStorageCart) {
      handleToPage(`/shop/detail/list/product/subcategorie/${idRestaurante}`);
    }
    if (window.atob(idRestaurante) !== dataStorageShop?.idRestaurante) {
      handleToPage(`/shop/detail/list/product/subcategorie/${idRestaurante}`);
    }
  }, []);
  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="AdditionalRequest" />
      <CssBaseline />
      {product && (
        <>
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            marginBottom="120px"
          >
            <Grid className={classeStyle.gridMain}>
              <h4 className={classeStyle.titleMain}>{product.dsNome}</h4>
              <p className={classeStyle.textQtFlavorMain}>
                {qtOptionLevelMax} /{' '}
                {product.niveis[product.optionLevelInit]?.qtMaxOpcao} (Opções
                selecionados)
              </p>
              <h5>{product.niveis[product.optionLevelInit]?.dsTitulo}</h5>
              <Grid>
                {product.niveis[product.optionLevelInit]?.opcoesNivel.map(
                  (optionLevelItem: any) => (
                    <Grid
                      container
                      justifyContent="space-between"
                      key={optionLevelItem.idOpcaoNivel}
                    >
                      <Grid
                        item
                        className={classeStyle.gridProduct}
                        xs={optionLevelItem.dsImagem ? 9.5 : 9.5}
                        sm={optionLevelItem.dsImagem ? 10 : 10}
                      >
                        <Grid container>
                          <Grid
                            container
                            item
                            justifyContent="flex-start"
                            alignContent="center"
                            xs={12}
                            sm={12}
                          >
                            {optionLevel.find(
                              (optionLevelData: any) =>
                                Number(optionLevelData.idOpcaoNivel) ===
                                Number(optionLevelItem.idOpcaoNivel),
                            ) ? (
                              <Grid container alignItems="center">
                                <Grid
                                  item
                                  xs={3}
                                  sm={2}
                                  className={classeStyle.gridIncrementQtProduct}
                                  justifyContent="center"
                                >
                                  <IconLess
                                    onClick={() =>
                                      handleSetQtOptionLevel(
                                        optionLevelItem.idOpcaoNivel,
                                        optionLevelItem.qtItens - 1,
                                        'decrement',
                                      )
                                    }
                                  />
                                  <p className={classeStyle.textQtProduct}>
                                    {optionLevelItem?.qtItens}
                                  </p>
                                  <IconPlus
                                    onClick={() =>
                                      handleSetQtOptionLevel(
                                        optionLevelItem.idOpcaoNivel,
                                        optionLevelItem.qtItens + 1,
                                        'increment',
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid item xs={9} sm={10}>
                                  <h5 className={classeStyle.titleProduct}>
                                    {optionLevelItem.dsNome}
                                  </h5>
                                  <p className={classeStyle.textDesProduct}>
                                    {optionLevelItem.dsDescricao}
                                  </p>
                                  <Grid
                                    className={classeStyle.gridVlQtProduct}
                                    style={
                                      product.niveis[product.optionLevelInit]
                                        .flgMostrarPreco == 0
                                        ? { justifyContent: 'end' }
                                        : { justifyContent: 'space-between' }
                                    }
                                  >
                                    {product.niveis[product.optionLevelInit]
                                      .flgMostrarPreco > 0 && (
                                      <p className={classeStyle.textVlProduct}>
                                        R$ {FormatPrice(optionLevelItem.vlItem)}
                                      </p>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            ) : (
                              <FormControlLabel
                                style={{
                                  width: 'auto',
                                  marginLeft: 0,
                                  marginRight: 0,
                                }}
                                onChange={handleSelectOptionLevel}
                                name="idOpcaoNivel"
                                value={optionLevelItem.idOpcaoNivel}
                                control={
                                  optionLevel.find(
                                    (optionLevelData: any) =>
                                      Number(optionLevelData.idOpcaoNivel) ===
                                      Number(optionLevelItem.idOpcaoNivel),
                                  ) ? (
                                    <Checkbox
                                      icon={<IconCheck />}
                                      checkedIcon={<IconChecked />}
                                      className={classeStyle.svgCheck}
                                      checked
                                    />
                                  ) : (
                                    <Checkbox
                                      icon={<IconCheck />}
                                      checkedIcon={<IconChecked />}
                                      className={classeStyle.svgCheck}
                                      checked={false}
                                    />
                                  )
                                }
                                label={
                                  <Grid>
                                    <h5 className={classeStyle.titleProduct}>
                                      {optionLevelItem.dsNome}
                                    </h5>
                                    <p className={classeStyle.textDesProduct}>
                                      {optionLevelItem.dsDescricao}
                                    </p>
                                    <Grid
                                      className={classeStyle.gridVlQtProduct}
                                      style={
                                        product.niveis[product.optionLevelInit]
                                          .flgMostrarPreco == 0
                                          ? { justifyContent: 'end' }
                                          : { justifyContent: 'space-between' }
                                      }
                                    >
                                      {product.niveis[product.optionLevelInit]
                                        .flgMostrarPreco > 0 && (
                                        <p
                                          className={classeStyle.textVlProduct}
                                        >
                                          R${' '}
                                          {FormatPrice(optionLevelItem.vlItem)}
                                        </p>
                                      )}
                                    </Grid>
                                  </Grid>
                                }
                              />
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      {optionLevelItem.dsImagem &&
                        optionLevelItem.dsImagem != 'null' && (
                          <Grid
                            item
                            display="flex"
                            alignItems="center"
                            onClick={() => zoomImg(optionLevelItem)}
                          >
                            <img
                              src={`${
                                process.env.REACT_APP_API_IMG +
                                optionLevelItem.dsImagem
                              }`}
                              alt="banner"
                              className={classeStyle.bannerProduct}
                            />
                          </Grid>
                        )}
                    </Grid>
                  ),
                )}
              </Grid>
            </Grid>
            <Grid className={classeStyle.gridButtonAndValueToC}>
              {vlProduct >= 0 && (
                <Grid item xs={12} container justifyContent="center">
                  <h4
                    style={{
                      bottom: 50,
                    }}
                  >
                    {`R$ ${FormatPrice(vlProduct)}`}
                  </h4>
                </Grid>
              )}
              <Grid item xs={12} container justifyContent="center">
                <Button
                  className={classeStyle.btnSubmit}
                  style={{
                    bottom: 15,
                    width: '80%',
                    maxWidth: 680,
                  }}
                  variant="contained"
                  onClick={handleAddOptionLevelCart}
                >
                  <p className={classeStyle.textBtnSubmit}>Continuar</p>
                  <IconArrowRight />
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <ModalMessage
            open={openUserNotParams}
            onClose={() => setOpenUserNotParams(false)}
            title="Atenção"
            description={errorInfo}
            primaryText="Ok"
            primaryAction={() => {
              setOpenUserNotParams(false);
            }}
          />
          <Modal
            open={openModalZoonImgProduct}
            onClose={() => setOpenModalZoonImgProduct(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                ...styleModalItemMenu,
                background: '#fff',
                p: 2,
                border: '1px solid #e9e3e3',
              }}
            >
              <Grid
                container
                item
                textAlign="center"
                justifyContent="center"
                alignItems="center"
              >
                {optionSelected && (
                  <>
                    {optionSelected?.dsImagem && (
                      <Grid item display="flex">
                        <img
                          src={`${
                            process.env.REACT_APP_API_IMG +
                            optionSelected.dsImagem
                          }`}
                          alt="banner"
                          className={classeStyle.bannerProduct}
                          style={{
                            width: '100%',
                            maxWidth: 680,
                            height: 'auto',
                          }}
                        />
                      </Grid>
                    )}
                    <Grid container padding={2}>
                      <Grid item xs={9} sm={10} textAlign="left">
                        <h3 className={classeStyle.titleProduct}>
                          {optionSelected.dsNome}
                        </h3>
                        <p className={classeStyle.textDesProduct}>
                          {optionSelected.dsDescricao}
                        </p>
                      </Grid>
                      {product.niveis[product.optionLevelInit].flgMostrarPreco >
                        0 && (
                        <Grid item xs={3} sm={2}>
                          <p className={classeStyle.textDesValue}>
                            A partir de
                          </p>
                          <p className={classeStyle.textValue}>
                            R$ {FormatPrice(optionSelected.vlItem)}
                          </p>
                        </Grid>
                      )}
                    </Grid>
                    <Button
                      className={classeStyle.btnSubmit}
                      onClick={() => setOpenModalZoonImgProduct(false)}
                      variant="contained"
                    >
                      Voltar
                    </Button>
                  </>
                )}
              </Grid>
            </Box>
          </Modal>
        </>
      )}
    </Container>
  );
};

export default RequestOptionLevel;
